module.exports = __webpack_public_path__ + "static/media/peerpal.a51de550.png";